
import axios from '../../axios/interceptor.js';

// Get a Stripe Checkout URL
export const createCheckoutSession = async (planId, frequency) => {
    const response = await axios.post(`/customer/payments/create-checkout-session`,
        { planId, frequency }
    );
    return response.data; // Expected { url: 'https://checkout.stripe.com/...' }
};

// Get a Stripe Portal URL
export const createPortalSession = async () => {
    const response = await axios.post(`/customer/payments/create-portal-session`,
        {},
    );
    return response.data; // Expected { url: 'https://billing.stripe.com/...' }
};